'use strict';

angular.module('nfseApp')
    .factory('NotaNacional', function ($resource, DateUtils) {

        function convertDateFromServer(data) {
            if (data.dataHoraProcessamento) {
                data.dataHoraProcessamento = DateUtils.convertLocaleDateFromServer(data.dataHoraProcessamento);
            }
        }

        return $resource('api/nota-nacional/:id', {}, {
            'integrar': {
                url: 'api/nota-nacional/integrar',
                method: 'GET'
            },
            'integrarEventoCancelamento': {
                url: 'api/nota-nacional/integrar-evento-cancelamento',
                method: 'GET'
            },
            'integrarEventosCancelamentoPendentes': {
                url: 'api/nota-nacional/integrar-eventos-cancelamento-pendentes',
                method: 'GET',
                // O endpoint devolve apenas a quantidade enfileirada; o $resource espera um objeto.
                // Na resposta de erro o corpo tem de passar intacto, senão o interceptor global
                // não encontra a mensagem para exibir ao usuário.
                transformResponse: function (data, headers, status) {
                    var corpo = angular.fromJson(data);
                    return status >= 200 && status < 300 ? {value: corpo} : corpo;
                }
            },
            // Processamento em massa: um POST com todos os documentos marcados, em vez de uma
            // chamada solta por linha. O servidor decide a operação de cada nota e devolve o resumo,
            // que é o único jeito de o operador saber o que não foi enviado e por quê.
            'integrarDocumentos': {
                url: 'api/nota-nacional/integrar-documentos',
                method: 'POST'
            },
            'buscarRetornosDfeAdn': {
                url: 'api/nota-nacional/retornos-dfe-adn',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    for (var i = 0; i < data.length; i++) {
                        var nota = data[i];
                        convertDateFromServer(nota);
                    }
                    return data;
                }
            },
            'buscarMensagensDfeAd': {
                url: 'api/nota-nacional/mensagens-dfe-adn',
                method: 'GET',
                isArray: true
            },
            'buscarIntegracoes': {
                method: 'POST',
                url: 'api/nota-nacional/buscar-integracoes',
                isArray: true
            },
            'buscarQuantidadePorErro': {
                method: 'GET',
                url: 'api/nota-nacional/buscar-quantidade-por-erro',
                isArray: true
            },
            'buscarQuantidadePorStatus': {
                method: 'GET',
                url: 'api/nota-nacional/buscar-quantidade-por-status',
                isArray: true
            },
            'reintegrarNotasPorCodigoErro': {
                url: 'api/nota-nacional/reintegrar-notas-por-codigo-erro',
                method: 'GET'
            },
        });
    });
